import React, { useState } from 'react';
import request from 'utils/request_ajax';
import { Icon } from 'ui';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { routes } from 'constants/config';
import InitialInformation from './InitialInformation';
import LessonGenerateActions from './LessonGenerateActions';
import AddTextSpaceBelow from './AddTextSpaceBelow';
import Formatting from './Formatting';
import Finish from './Finish';

export const MODAL_TYPES = {
  INITIAL_INFORMATION: 'INITIAL_INFORMATION',
  ADD_TEXT_SPACE_BELOW: 'ADD_TEXT_SPACE_BELOW',
  FORMATTING: 'FORMATTING',
  FINISH: 'FINISH',
};

const MODAL_COMPONENTS = {
  [MODAL_TYPES.INITIAL_INFORMATION]: {
    current: InitialInformation,
    previous: null,
    next: MODAL_TYPES.ADD_TEXT_SPACE_BELOW,
  },
  [MODAL_TYPES.ADD_TEXT_SPACE_BELOW]: {
    current: AddTextSpaceBelow,
    previous: MODAL_TYPES.INITIAL_INFORMATION,
    next: MODAL_TYPES.FORMATTING,
  },
  [MODAL_TYPES.FORMATTING]: {
    current: Formatting,
    previous: MODAL_TYPES.ADD_TEXT_SPACE_BELOW,
    next: MODAL_TYPES.FINISH,
  },
  [MODAL_TYPES.FINISH]: {
    current: Finish,
    previous: MODAL_TYPES.FORMATTING,
    next: null,
  },
};

const LessonGenerateModal = ({ closeModal, openLessonGenerateModal }) => {
  const [modal, setModal] = useState(MODAL_TYPES.INITIAL_INFORMATION);
  const [lessonText, setLessonText] = useState('');
  const [formatChoice, setFormatChoice] = useState(true);

  const previous = () => {
    if (modal === MODAL_TYPES.INITIAL_INFORMATION) {
      closeModal();
      openLessonGenerateModal();
    } else {
      setModal(MODAL_COMPONENTS[modal].previous);
    }
  };

  const nextModal = () => setModal(MODAL_COMPONENTS[modal].next);

  const next = () => {
    if (modal === MODAL_TYPES.FINISH) {
      closeModal();
    } else if (modal === MODAL_TYPES.FORMATTING) {
      // todo - we also need to pass workspace id
      request
        .postScript(routes.LESSON_GENERATE.TEXT, {
          raw_input: lessonText,
          title: 'Fun facts about horses', // todo - need to fix passing in title
          description: 'A couple of interesting facts about horses.', // todo - need to fix passing in description
          gpt_formatted: formatChoice,
        })
        .then(() => {
          nextModal();
        })
        .fail(error => {
          console.error(error);
        });
    } else {
      nextModal();
    }
  };

  const onLessonTextChange = event => {
    setLessonText(event.target.value);
  };

  const renderModalComponent = () => {
    const ModalComponent = MODAL_COMPONENTS[modal].current;
    if (!ModalComponent) {
      return null; // in the future we will render an error page
    }
    return (
      <ModalComponent
        lessonText={lessonText}
        onLessonTextChange={onLessonTextChange}
        previous={previous}
        next={next}
        formatChoice={formatChoice}
        setFormatChoice={setFormatChoice}
      />
    );
  };
  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container LessonGenerateModal">
          <div className="LessonGenerateModal--body">
            {renderModalComponent()}
            <LessonGenerateActions
              previous={previous}
              next={next}
              modal={modal}
              isNextBtnDisabled={
                modal === MODAL_TYPES.ADD_TEXT_SPACE_BELOW &&
                !lessonText.trim().length
              }
              displayWordCount={modal === MODAL_TYPES.ADD_TEXT_SPACE_BELOW}
              lessonText={lessonText}
            />
            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              aria-label={t('common.close')}
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default LessonGenerateModal;
